export default class ParameterValue {
    static fromData(data) {
        if (!data) {
            return;
        }

        let parameterValue = new ParameterValue();
        parameterValue.id = data.id;
        parameterValue.value = data.value;

        Object.seal(parameterValue);
        return parameterValue;
    }
}
